/** Names that appear on both the guest page and the dashboard. */
export const enShared = {
  // Reservation statuses (keyed by status code)
  'status.booked': 'Booked',
  'status.left_message': 'Left message',
  'status.wrong_number': 'Wrong number',
  'status.no_answer': 'No answer',
  'status.confirmed': 'Confirmed',
  'status.running_late': 'Running late',
  'status.arrived': 'Arrived',
  'status.partially_arrived': 'Partially arrived',
  'status.waiting_in_bar': 'Waiting in bar',
  'status.partially_seated': 'Partially seated',
  'status.seated': 'Seated',
  'status.drinks': 'Drinks',
  'status.appetizer': 'Appetizer',
  'status.entree': 'Entree',
  'status.dessert': 'Dessert',
  'status.course_1': 'Course 1',
  'status.course_2': 'Course 2',
  'status.course_3': 'Course 3',
  'status.course_4': 'Course 4',
  'status.cleared': 'Cleared',
  'status.check_dropped': 'Check dropped',
  'status.paid': 'Paid',
  'status.bussing_needed': 'Bussing needed',
  'status.finished': 'Finished',
  'status.cancelled': 'Cancelled',
  'status.no_show': 'No-show',

  // Why a time is unavailable
  'reason.closed': 'Closed',
  'reason.outside_shift': 'Not serving',
  'reason.cutoff_passed': 'Too soon',
  'reason.beyond_horizon': 'Not open yet',
  'reason.online_off': 'Phone only',
  'reason.party_too_small': 'Party too small',
  'reason.party_too_large': 'Call us',
  'reason.pacing_limit': 'Fully booked',
  'reason.no_capacity': 'Fully booked',

  // Seating areas and occasions (the codes are stored; the text is localised)
  'env.indoor': 'Indoor',
  'env.outdoor': 'Outdoor',
  'env.bar': 'Bar',
  'env.patio': 'Patio',
  'env.private': 'Private room',
  'occasion.none': 'None',
  'occasion.birthday': 'Birthday',
  'occasion.anniversary': 'Anniversary',
  'occasion.date_night': 'Date night',
  'occasion.business': 'Business meal',
  'occasion.celebration': 'Celebration',

  // Server error codes (the server message is English; these are shown instead)
  'err.slot_unavailable': 'That time was just taken.',
  'err.offer_expired': 'That time is out of date.',
  'err.invalid_offer': 'That time is no longer valid.',
  'err.lock_expired': 'The hold has expired. Please choose a time again.',
  'err.lock_not_found': 'We could not find that hold.',
  'err.payment_required': 'A card is required to complete this booking.',
  'err.payment_failed': 'The payment did not go through.',
  'err.payment_unavailable': 'Payments are not available right now.',
  'err.not_found': 'Not found.',
  'err.invalid_request': 'Please check the details and try again.',
  'err.invalid_state': 'That is not possible in the current state.',
  'err.table_conflict': 'That table is already taken for that time.',
  'err.pacing_limit': 'That time is fully booked.',
  'err.unauthorized': 'Please sign in.',
  'err.forbidden': 'You are not allowed to do that.',
  'err.rate_limited': 'Too many attempts. Please try again later.',
  'err.passcode_required': 'The restaurant passcode is required for this.',
  'err.passcode_invalid': 'That passcode is not correct.',
  'err.mfa_required': 'A verification code is required.',
  'err.mfa_setup_required': 'Set up two-step sign-in to continue.',
  'err.config_invalid': 'The configuration has problems that must be fixed first.',
  'err.config_stale': 'The live configuration changed. Reload your draft before publishing.',
  'err.network': 'Could not reach the server. Check your connection.',
  'err.unknown': 'Something went wrong. Please try again.',
  'err.phone_required': 'Please enter a phone number.',
  'err.image_required': 'Please choose an image file.',
  'err.image_too_large': 'That image is larger than 512 KB.',
  'err.image_unsupported': 'Only PNG, JPEG, WebP and GIF images are accepted.',
  'err.too_many_assets': 'Too many uploaded images. Please contact support.',
  'env.smoking': 'Smoking area',
  'env.lounge': 'Lounge',
  'env.other': 'Other',
  'err.restaurant_unavailable': 'Online booking is not available right now.',
  'err.account_suspended': 'This account is suspended. Please contact support.',
  'err.account_locked': 'Too many attempts. Please try again later.',
  'err.access_restricted': 'This offer is for invited guests. Please use the email address your restaurant knows.',
  'err.limit_reached': 'You already have several alerts for this restaurant.',
  'err.feature_disabled': 'This feature is switched off in the restaurant settings.',
  'err.room_taken': 'That room is already confirmed for another event at this time.',
  'err.sms_limit': 'The monthly text message allowance is used up.',
  'err.sms_failed': 'The text message could not be sent.',
  'err.terms_required': 'Please accept the terms to continue.',
  'reason.experience_full': 'Fully booked',
  'reason.experience_unavailable': 'Not part of this offer',
  'err.experience_unavailable': 'This offer is not available for that booking.',
} as const;
